"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { useTheme } from "next-themes";
import { apiJson } from "@/lib/account/api-client";

/**
 * Theme source-of-truth bridge (2.2 §12.14). next-themes keeps a device-local cache
 * (localStorage) that paints the correct theme on FIRST paint (no flash). Once the
 * session resolves, this pulls the user's SERVER-stored theme and applies it — so the
 * server value wins and the theme follows the person to any device. Runs once per
 * authenticated mount; unauthenticated surfaces (login) are skipped.
 */
export function ThemeSync() {
  const { status } = useSession();
  const { setTheme } = useTheme();

  useEffect(() => {
    if (status !== "authenticated") return;
    let cancelled = false;
    apiJson<{ preferences: { theme?: string } | null }>("/api/account/preferences").then((r) => {
      if (cancelled || !r.ok) return;
      const theme = r.data?.preferences?.theme;
      if (theme === "light" || theme === "dark" || theme === "system") setTheme(theme);
    });
    return () => {
      cancelled = true;
    };
  }, [status, setTheme]);

  return null;
}
